import type { ReactNode } from "react";

/**
 * Code-question test results, readable. There is no real code sandbox yet: every run comes from a
 * deterministic stand-in (image digest "sha256:fake-…"), so this must say SIMULATED (GROUND_RULES:
 * a simulated provider is always labelled) — and the live judge does not use it in the score.
 */
export function CodeRunSummary({ result }: { result: unknown }): ReactNode {
  const r = result as { cases?: { name?: string; status?: string; timeMs?: number }[]; compileOk?: boolean; imageDigest?: string } | null;
  const cases = Array.isArray(r?.cases) ? r!.cases! : [];
  const simulated = typeof r?.imageDigest !== "string" || r.imageDigest.includes("fake");
  const passed = cases.filter((c) => c.status === "pass").length;
  return (
    <div className="t1-coderun">
      <div className="t1-coderun-head">
        <b>Test cases</b>
        {cases.length > 0 && <span className="tnum">{passed} of {cases.length} passed</span>}
        {simulated && <span className="pill n">Simulated run — not real execution, not used in the score</span>}
      </div>
      {r?.compileOk === false && <p className="sm" style={{ margin: "6px 0 0", color: "var(--crit)" }}>Did not compile.</p>}
      {cases.length > 0 && (
        <ul className="t1-coderun-list">
          {cases.map((c, i) => (
            <li key={i}>
              <span className={`pill ${c.status === "pass" ? "v" : c.status === "fail" ? "f" : "r"}`}>{c.status === "pass" ? "Pass" : c.status === "fail" ? "Fail" : "Error"}</span>
              <span>Case {i + 1}</span>
              {typeof c.timeMs === "number" && <span className="mut sm tnum">{c.timeMs} ms</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
